import React from 'react';

import type { FC } from 'react';

export const Warn: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
      <path d="M3.35259 15.3787H14.6476C15.8026 15.3787 16.5226 14.1262 15.9451 13.1287L10.2976 3.37117C9.72009 2.37367 8.28009 2.37367 7.70259 3.37117L2.05509 13.1287C1.47759 14.1262 2.19759 15.3787 3.35259 15.3787ZM9.00009 10.1287C8.58759 10.1287 8.25009 9.79117 8.25009 9.37867V7.87867C8.25009 7.46617 8.58759 7.12867 9.00009 7.12867C9.41259 7.12867 9.75009 7.46617 9.75009 7.87867V9.37867C9.75009 9.79117 9.41259 10.1287 9.00009 10.1287ZM9.75009 13.1287H8.25009V11.6287H9.75009V13.1287Z" />
    </svg>
  );
};
